(function () {
  'use strict';

  var STYLE_ID = 'sicilus-live-ux-hotfix-css';
  var locale = ((document.documentElement.lang || 'it').slice(0, 2).toLowerCase());
  var isItalian = locale === 'it';
  var scheduled = false;
  var observer;
  var idle = window.requestIdleCallback || function (cb) { return window.setTimeout(cb, 160); };
  var businessBase = 'https://business.sicilus.com/cesti-natalizi-aziendali/?utm_source=sicilus&utm_medium=referral&utm_campaign=b2b_bridge';
  var businessUrl = businessBase + '&utm_content=homepage_corporate_block';
  var legacyBusinessUrl = businessBase + '&utm_content=legacy_company_page';

  if (locale === 'sv') {
    businessUrl = '/sv#SicilusCorporateQuoteHome';
    legacyBusinessUrl = businessUrl;
  }

  var localizedCopy = {
    sv: { announcement: 'Fri frakt i Italien från 89 € och i EU från 149 € (beställningsvaror och drycker omfattas av särskilda fraktvillkor)', welcome: 'Välkommen till Sicilus', support: 'Kundservice', phone: 'Telefon:' },
    it: { announcement: 'Spedizione gratuita in Italia da 89 € e in Europa da 149 € (esclusi prodotti su ordinazione e bibite)', welcome: 'Benvenuti su Sicilus', support: 'Assistenza', phone: 'Telefono:' },
    en: { announcement: 'Free shipping in Italy from €89 and across Europe from €149 (made-to-order products and drinks excluded)', welcome: 'Welcome to Sicilus', support: 'Customer support', phone: 'Phone:' },
    fr: { announcement: 'Livraison gratuite en Italie dès 89 € et en Europe dès 149 € (produits sur commande et boissons exclus)', welcome: 'Bienvenue chez Sicilus', support: 'Service client', phone: 'Téléphone :' },
    de: { announcement: 'Kostenloser Versand in Italien ab 89 € und europaweit ab 149 € (Bestellprodukte und Getränke ausgenommen)', welcome: 'Willkommen bei Sicilus', support: 'Kundenservice', phone: 'Telefon:' },
    es: { announcement: 'Envío gratuito en Italia desde 89 € y en Europa desde 149 € (productos bajo pedido y bebidas excluidos)', welcome: 'Bienvenidos a Sicilus', support: 'Atención al cliente', phone: 'Teléfono:' },
    pl: { announcement: 'Bezpłatna dostawa we Włoszech od 89 € i w Europie od 149 € (z wyłączeniem produktów na zamówienie i napojów)', welcome: 'Witamy w Sicilus', support: 'Obsługa klienta', phone: 'Telefon:' }
  };
  var copy = localizedCopy[locale] || localizedCopy.en;

  function redirectLegacyCompanyPage() {
    var path = (window.location.pathname || '').replace(/\/+$/, '');
    if (!/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/pages\/registrazione-aziende$/i.test(path)) return false;
    window.location.replace(legacyBusinessUrl);
    return true;
  }

  if (redirectLegacyCompanyPage()) return;

  if (/\/cart\/?$/i.test(window.location.pathname || '')) {
    document.documentElement.classList.add('sicilus-cart-page');
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '#shopify-section-template--29106826871048__1778622554a3ad6b74 [class*="ai-category-banners__item-"]{position:relative!important;isolation:isolate!important;overflow:hidden!important}',
      '#shopify-section-template--29106826871048__1778622554a3ad6b74 [class*="ai-category-banners__item-"]::after{content:""!important;position:absolute!important;inset:0!important;z-index:1!important;pointer-events:none!important;background:linear-gradient(180deg,rgba(43,38,32,.16),rgba(43,38,32,.72))!important}',
      '#shopify-section-template--29106826871048__1778622554a3ad6b74 [class*="ai-category-banners__content-"]{position:relative!important;z-index:2!important;text-shadow:0 2px 12px rgba(0,0,0,.58)!important}',
      '#shopify-section-template--29106826871048__1778622554a3ad6b74 [class*="ai-category-banners__title-"]{color:#fffaf0!important;text-shadow:0 2px 12px rgba(0,0,0,.58)!important}',
      '.sicilus-audience__card:after{background:linear-gradient(180deg,rgba(18,20,16,.08) 0%,rgba(18,20,16,.34) 34%,rgba(18,20,16,.78) 62%,rgba(18,20,16,.96) 100%)!important}',
      '.sicilus-audience__content{color:#fffaf0!important}',
      '.sicilus-audience__content .sicilus-audience__eyebrow{color:#e3c777!important;opacity:1!important;text-shadow:0 2px 10px rgba(0,0,0,.72)!important}',
      '.sicilus-audience__content .sicilus-audience__title,.sicilus-audience__content .sicilus-audience__text,.sicilus-audience__content .sicilus-audience__note{color:#fffaf0!important;opacity:1!important;text-shadow:0 2px 14px rgba(0,0,0,.72)!important}',
      '.hdt-page-cart__footer .sicilus-cart-reassurance{display:none!important}',
      '.hdt-product__order{display:none!important}',
      '#shopify-block-aov_ai_free_gift_bxgy_avada_progress_bar_4BJH3w,[id*="aov_ai_free_gift"],[data-block-id*="aov_ai_free_gift"],[class*="avada-progress"]{display:none!important}',
      '.sicilus-cart-page .hdt-main-heading .hdt-heading-liquid{color:#fff!important;text-shadow:0 2px 8px rgba(0,0,0,.65)!important}',
      '@media (min-width:1150px){.hdt-header-search_form .hdt-search_form .hdt-search__categories{flex:0 0 220px!important;width:220px!important;min-width:220px!important;max-width:220px!important}.hdt-header-search_form .hdt-search_form .hdt-search__categories select{width:100%!important;max-width:none!important}}',
      '@media (prefers-reduced-motion:reduce){*,::before,::after{animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition-duration:.01ms!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function replaceTextNode(node) {
    if (!node || !node.nodeValue) return;
    var text = node.nodeValue;
    var next = text
      .replace(/\bForniture Horeca\b/g, 'Forniture HORECA')
      .replace(/\bHoreca\b/g, 'HORECA')
      .replace(/\bFILIERIA CORTA\b/g, 'FILIERA CORTA')
      .replace(/SPEDIZIONE GRATUITA ITALIA DA 89 EURO - FREE EU SHIPPING FROM 149 EURO/g, copy.announcement)
      .replace(/Welcome to our store!/g, copy.welcome)
      .replace(/Assistenza\s*\?/g, copy.support)
      .replace(/Phone:/g, copy.phone);

    if (isItalian) {
      next = next
        .replace(/\bFrom\s*(€\s*[0-9.,]+)/g, 'Da $1')
        .replace(/\bFrom\s*(€[0-9.,]+)/g, 'Da $1')
        .replace(/\(New\)/g, '- Novità')
        .replace(/CARRELLO\s*-\s*CART/g, 'CARRELLO');
    }
    if (next !== text) node.nodeValue = next;
  }

  function normalizeText(root) {
    if (!document.body) return;
    var scope = root && root.nodeType === 1 ? root : document.body;
    var pattern = isItalian
      ? /From\s*€|Forniture Horeca|Horeca|FILIERIA CORTA|\(New\)|SPEDIZIONE GRATUITA ITALIA DA 89 EURO|Welcome to our store!|Assistenza\s*\?|Phone:|CARRELLO\s*-\s*CART/
      : /Forniture Horeca|Horeca|FILIERIA CORTA|SPEDIZIONE GRATUITA ITALIA DA 89 EURO|Welcome to our store!|Assistenza\s*\?|Phone:/;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || /^(SCRIPT|STYLE|TEXTAREA|INPUT|NOSCRIPT|SVG)$/i.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return pattern.test(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var node;
    var count = 0;
    while ((node = walker.nextNode()) && count < 180) {
      replaceTextNode(node);
      count += 1;
    }
  }

  function normalizeLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a[href*="wa.me/+393203554877"],a[href="https://api.whatsapp.com/send/"]').forEach(function (link) {
      link.href = 'https://wa.me/393203554877';
    });
    scope.querySelectorAll('a[href*="/pages/registrazione-aziende"]').forEach(function (link) {
      link.href = businessUrl;
      link.removeAttribute('target');
      link.removeAttribute('rel');
      if (isItalian && /richiedi\s+una\s+quotazione/i.test(link.textContent || '')) link.textContent = 'RICHIEDI UNA PROPOSTA AZIENDALE';
    });
  }

  function normalizeToolbar(root) {
    if (!isItalian) return;
    var scope = root && root.querySelectorAll ? root : document;
    var labels = {
      '.hdt-toolbart-shop .hdt-toolbar-label': 'Catalogo',
      '.hdt-toolbart-cart .hdt-toolbar-label': 'Carrello',
      '.hdt-toolbart-account .hdt-toolbar-label': 'Profilo',
      '.hdt-toolbart-search .hdt-toolbar-label': 'Cerca',
      '.hdt-toolbart-wishlist .hdt-toolbar-label': 'Preferiti'
    };
    Object.keys(labels).forEach(function (selector) {
      scope.querySelectorAll(selector).forEach(function (el) { el.textContent = labels[selector]; });
    });
    scope.querySelectorAll('[aria-label="drawer-search"]').forEach(function (el) { el.setAttribute('aria-label', 'Cerca'); });
  }

  function lazyLoad(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('iframe:not([loading])').forEach(function (iframe) { iframe.loading = 'lazy'; });
    scope.querySelectorAll('img:not([loading])').forEach(function (img) {
      if (!img.closest('#MainContent .shopify-section:first-child')) img.loading = 'lazy';
    });
  }

  function removeCompetingCommerceMessages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.hdt-page-cart__footer .sicilus-cart-reassurance,[id*="aov_ai_free_gift"],[data-block-id*="aov_ai_free_gift"],[class*="avada-progress"]').forEach(function (el) {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function run(root) {
    scheduled = false;
    injectStyle();
    normalizeToolbar(root);
    normalizeLinks(root);
    lazyLoad(root);
    removeCompetingCommerceMessages(root);
    idle(function () { normalizeText(root); });
  }

  function schedule(root) {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () { run(root); }, 80);
  }

  function start() {
    run(document.body);
    if ('MutationObserver' in window) {
      observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            schedule(mutations[i].target);
            break;
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  window.addEventListener('load', function () { schedule(document.body); }, { once: true });
  window.addEventListener('pageshow', function (event) { if (event.persisted) schedule(document.body); });
  document.addEventListener('shopify:section:load', function (event) { schedule(event.target); });
})();


/* SICILUS Q4 market-context self-heal 2026-09-25 */
(function () {
  'use strict';

  if (window.__sicilusItalyMarketSelfHealInstalled) return;
  window.__sicilusItalyMarketSelfHealInstalled = true;

  var ATTEMPT_KEY = 'sicilus:italy-market-self-heal:v1';

  function isItalianBrowserInItalyTimezone() {
    var languages = (navigator.languages && navigator.languages.length)
      ? navigator.languages
      : [navigator.language || ''];
    var italianBrowser = languages.some(function (language) {
      return /^it(?:-|$)/i.test(language || '');
    });
    var timezone = '';
    try {
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch (error) {}
    return italianBrowser && /^(Europe\/Rome|Europe\/Vatican|Europe\/San_Marino)$/i.test(timezone);
  }

  function cleanReturnTo() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('country');
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return window.location.pathname + window.location.search + window.location.hash;
    }
  }

  function setItalyLocalization() {
    try { window.sessionStorage.setItem(ATTEMPT_KEY, '1'); } catch (error) {}

    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.hidden = true;

    var fields = {
      form_type: 'localization',
      utf8: '✓',
      _method: 'PUT',
      country_code: 'IT',
      language_code: (window.Shopify && Shopify.language) || document.documentElement.lang || 'it',
      return_to: cleanReturnTo()
    };

    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  function runItalyMarketSelfHeal() {
    if (!window.Shopify || !Shopify.country || Shopify.country === 'IT' || Shopify.designMode) return;
    try {
      if (window.sessionStorage.getItem(ATTEMPT_KEY) === '1') return;
    } catch (error) {}

    var currentCountry = String(Shopify.country || '').toUpperCase();
    var root = (Shopify.routes && Shopify.routes.root) || '/';
    var endpoint = root + 'browsing_context_suggestions.json'
      + '?country[enabled]=true'
      + '&country[exclude]=' + encodeURIComponent(currentCountry);

    fetch(endpoint, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Browsing context request failed');
        return response.json();
      })
      .then(function (data) {
        var detected = data
          && data.detected_values
          && data.detected_values.country
          && String(data.detected_values.country.handle || '').toUpperCase();

        if (detected === 'IT' || isItalianBrowserInItalyTimezone()) {
          setItalyLocalization();
        }
      })
      .catch(function () {
        if (isItalianBrowserInItalyTimezone()) setItalyLocalization();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runItalyMarketSelfHeal, { once: true });
  } else {
    runItalyMarketSelfHeal();
  }
})();
